import React from "react";
import usePro from "@/hooks/usePro";

export default function QADebugPanel() {
  const { 
    isPro, 
    paywallEnabled, 
    paywallTestMode, 
    testModeActive,
    effectivePaywallEnabled,
    tokenPresent 
  } = usePro();

  // Only show when ?debug=1 is in URL
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  if (params.get("debug") !== "1") return null;

  return (
    <div className="fixed bottom-4 right-4 bg-slate-900 text-white p-4 rounded-lg shadow-xl text-xs font-mono z-50 max-w-xs">
      <div className="font-bold text-amber-400 mb-2">🔧 QA Debug Panel</div>
      <div className="space-y-1">
        <div className="flex justify-between">
          <span className="text-slate-400">paywallEnabled:</span>
          <span className={paywallEnabled ? "text-red-400" : "text-green-400"}>
            {paywallEnabled ? "true" : "false"}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-400">paywallTestMode:</span>
          <span className={paywallTestMode ? "text-amber-400" : "text-slate-500"}>
            {paywallTestMode ? "true" : "false"}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-400">testModeActive:</span>
          <span className={testModeActive ? "text-amber-400" : "text-slate-500"}>
            {testModeActive ? "true" : "false"}
          </span>
        </div>
        <div className="flex justify-between border-t border-slate-700 pt-1 mt-1">
          <span className="text-slate-400">effectivePaywall:</span>
          <span className={effectivePaywallEnabled ? "text-red-400 font-bold" : "text-green-400 font-bold"}>
            {effectivePaywallEnabled ? "ON" : "OFF"}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-400">isPro:</span>
          <span className={isPro ? "text-green-400" : "text-slate-500"}>
            {isPro ? "true" : "false"}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-slate-400">tokenPresent:</span>
          <span className={tokenPresent ? "text-green-400" : "text-slate-500"}>
            {tokenPresent ? "true" : "false"}
          </span>
        </div>
      </div>
    </div>
  );
}
